export const objectNotEmpty = <T>(obj: T) => !!obj && !!Object.keys(obj).length;
